import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import moment from 'moment-timezone';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import Api from '@/utils/api';

export default {
  props: {
    managerList: {
      type: Array,
      default () {
        return [];
      },
    },
  },
  components: {
    Multiselect,
    DatePicker,
    preloader,
    empty,
  },
  data () {
    return {
      qaResult: [],

      projectsList: [],

      params: {
        projectId: {
          ID: '',
          Name: '',
        },
        status: 'all',
        manager: '',
        created_on: '',
      },

      load: true,
    };
  },
  watch: {
    'params.status' () {
      this.getQuality();
    },
    'params.created_on' () {
      this.getQuality();
    },
  },
  created () {
    this.getQuality();
  },
  methods: {

    /**
         * Method return string for multiselect
         *
         * @param {Number} count
         */
    limitText (count) {
      return `and ${count} others manager`;
    },

    /**
         * Method for handler selected
         *
         * @param {String} type
         * @param {Object} option
         */
    selectItem (type, option) {
      this.params[type] = option;
      this.getQuality();
    },

    /**
         * Method for handler selected
         *
         * @param {String} type
         */
    removeItem (type) {
      this.params[type] = '';
      this.getQuality();
    },

    getProjects () {
      const params = {
        manager: this.params.manager ? this.params.manager.ID : '',
      };

      Api.dashboard
        .getProjects(params)
        .then((data) => {
          if (data.data.Status) {
            this.projectsList = data.data.Data;
          }
        });
    },

    getQuality () {
      this.load = true;

      const query = {
        projectId: this.params.projectId.ID,
        status: this.params.status,
        created_on: (this.params.created_on !== '' && this.params.created_on[0] !== null) ? this.params.created_on.map((item) => moment(item).unix()).join(',') : '',
        manager: this.params.manager ? this.params.manager.ID : '',
      };

      this.getProjects();

      Api.dashboard.main
        .getQuality(query)
        .then((data) => {
          if (data.data.Status) {
            this.qaResult = data.data.Data;
            this.params.projectId = {
              ID: data.data.Data[0].ProjectID,
              Name: data.data.Data[0].ProjectName,
            };
          } else {
            this.qaResult = [];
          }

          this.load = false;
        });
    },

    checkRatingTask (item) {
      if (item.Rating == 50) {
        return 'quality-row__rating_normal';
      } else if (item.Rating > 50) {
        return 'quality-row__rating_good';
      } else if (item.Rating < 50) {
        return 'quality-row__rating_critical';
      } else {
        return '';
      }
    },
  },
};
